import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const backupManagerPlugin = createPlugin({
  id: 'backup-manager',
  routes: {
    root: rootRouteRef,
  },
});

export const BackupManagerPage = backupManagerPlugin.provide(
  createRoutableExtension({
    name: 'BackupManagerPage',
    component: () =>
      import('./components/BackupManagementPageComponent').then(m => m.BackupManagementPageComponent),
    mountPoint: rootRouteRef,
  }),
);
